
interface V3IconCardProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconCard = ({ stroke = "#ABB0BA", strokeWidth = "1.5", ...rest }: V3IconCardProps) => <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3.333H4a2 2 0 0 0-2 2v5.334a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.333a2 2 0 0 0-2-2ZM2 6.667h12M4.667 10h.006M7.333 10h1.334" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
</svg>